var render, staticRenderFns
import script from "./WxBtnStandard.vue?vue&type=script&lang=js"
export * from "./WxBtnStandard.vue?vue&type=script&lang=js"
import style0 from "./WxBtnStandard.vue?vue&type=style&index=0&id=a0bde96c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bde96c",
  null
  
)

export default component.exports